import React from 'react';
import MypageScheduleFailWrapper from 'components/MypageScheduleFailWrapper/MypageScheduleFailWrapper';

export default function MypageScheduleFailContainer() {
    return (
        <MypageScheduleFailWrapper />
    )
}
